import React, { useState } from 'react';
import { Card, Table, Typography, Button, Space, Form, Input, Progress, Tag, Tooltip, Modal, Tree, Drawer, Popconfirm, message } from 'antd';
import { SearchOutlined, ReloadOutlined, InboxOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import TargetTags from './TargetTags';
import { isStageFull, STAGE_NAME } from './buildConst';
import StageBuildAction from './StageBuildAction';
import useBuildDrawer from './useBuildDrawer';
import CreateAppDrawer from './CreateAppDrawer';
import UIDesignUploadDrawer from './UIDesignUploadDrawer';
import useUIDesign from './useUIDesign';
import { UI_STATUS, currentVersion, uiStatusLabel } from './uiDesignMock';
import { INITIAL_PROJECT_APPS } from './appMock';
import useAudit from './useAudit';
import AuditDrawer from './AuditDrawer';
import { auditStatusInfo } from './auditMock';
import useArchive from './useArchive';

const { Title, Text } = Typography;

// TODO: 联调时替换为接口数据
const MOCK_LIST = [
    { key: '10', id: 'OEM-1010', appName: '安视云', companyName: 'test-南京安视云科技有限公司', companyId: 'test-NJ010', targets: [{ platform: 'android', regions: ['cn', 'os'] }], p1: { done: 0, total: 18 }, p2: { done: 0, total: 20 }, createdAt: '2026-09-13 09:20' },
    { key: '11', id: 'OEM-1011', appName: '智慧园区', companyName: 'test-武汉智慧园区科技有限公司', companyId: 'test-WH011', targets: [{ platform: 'ios', regions: 'global' }], p1: { done: 0, total: 12 }, p2: { done: 0, total: 16 }, createdAt: '2026-09-12 15:40' },
    { key: '1', id: 'OEM-1001', appName: '智联安防', companyName: 'test-东莞康林物联网有限公司', companyId: 'test-JGSf0Nd7', targets: [{ platform: 'android', regions: ['cn'] }], p1: { done: 4, total: 12 }, p2: { done: 0, total: 14 }, createdAt: '2026-09-01 10:20' },
    { key: '2', id: 'OEM-1002', appName: '云眸智能', companyName: 'test-深圳智联科技有限公司', companyId: 'test-SZ888', targets: [{ platform: 'ios', regions: 'cn' }], p1: { done: 12, total: 12 }, p2: { done: 0, total: 8 }, createdAt: '2026-08-25 14:00' },
    { key: '3', id: 'OEM-1003', appName: 'GlobalEye', companyName: 'test-深圳云端科技有限公司', companyId: 'test-SZ666', targets: [{ platform: 'android', regions: ['os'] }, { platform: 'ios', regions: ['os'] }], p1: { done: 12, total: 12 }, p2: { done: 20, total: 28 }, createdAt: '2026-08-18 09:10' },
    { key: '4', id: 'OEM-1004', appName: '慧眼物联', companyName: 'test-杭州数智网络有限公司', companyId: 'test-HZ999', targets: [{ platform: 'android', regions: ['cn', 'os'] }], p1: { done: 2, total: 18 }, p2: { done: 0, total: 20 }, createdAt: '2026-09-05 16:40' },
    { key: '5', id: 'OEM-1005', appName: 'HmCamera', companyName: 'test-北京云联科技有限公司', companyId: 'test-BJ666', targets: [{ platform: 'ios', regions: 'global' }], p1: { done: 12, total: 12 }, p2: { done: 16, total: 16 }, createdAt: '2026-07-30 11:00' },
    { key: '6', id: 'OEM-1006', appName: '视界云', companyName: 'test-成都智眼科技有限公司', companyId: 'test-CD555', targets: [{ platform: 'android', regions: ['cn', 'os'] }, { platform: 'ios', regions: ['os'] }], p1: { done: 6, total: 20 }, p2: { done: 0, total: 18 }, createdAt: '2026-09-08 08:30' },
    { key: '7', id: 'OEM-1007', appName: '全场景智能', companyName: 'test-广州全场景科技有限公司', companyId: 'test-GZ001', targets: [{ platform: 'android', regions: ['cn', 'os'] }, { platform: 'ios', regions: 'global' }], p1: { done: 20, total: 20 }, p2: { done: 76, total: 76 }, createdAt: '2026-09-10 09:00' },
    { key: '8', id: 'OEM-1008', appName: '云视通', companyName: 'test-上海云视科技有限公司', companyId: 'test-SH008', targets: [{ platform: 'android', regions: ['cn', 'os'] }, { platform: 'ios', regions: 'global' }], p1: { done: 20, total: 20 }, p2: { done: 76, total: 76 }, createdAt: '2026-09-11 15:30' },
    { key: '9', id: 'OEM-1009', appName: '智联门禁', companyName: 'test-苏州智联门禁科技有限公司', companyId: 'test-SZ009', targets: [{ platform: 'android', regions: ['cn'] }, { platform: 'ios', regions: ['cn'] }], p1: { done: 12, total: 12 }, p2: { done: 0, total: 8 }, createdAt: '2026-09-12 10:30' },
    // 已归档（默认从主列表隐藏，见「已归档」抽屉）
    { key: '12', id: 'OEM-1012', appName: '测试无效项目', companyName: 'test-某测试企业有限公司', companyId: 'test-TEST12', targets: [{ platform: 'android', regions: ['cn'] }], p1: { done: 0, total: 12 }, p2: { done: 0, total: 14 }, createdAt: '2026-08-30 11:00' },
    { key: '13', id: 'OEM-1013', appName: '已下线项目', companyName: 'test-某下线企业有限公司', companyId: 'test-OFF13', targets: [{ platform: 'ios', regions: 'cn' }], p1: { done: 0, total: 12 }, p2: { done: 0, total: 8 }, createdAt: '2026-08-28 16:20' },
];

// 已创建的应用（示例数据）：{ [项目id]: [ { id, name, versions: [{ platformLabel, regionLabel, appId }] } ] }
const MOCK_APPS = INITIAL_PROJECT_APPS;

const CustomManage = () => {
    const navigate = useNavigate();
    const [records, setRecords] = useState(MOCK_LIST);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({ company: '', appName: '' });
    const { buildStates, openBuild, drawerElement } = useBuildDrawer();
    const [createApp, setCreateApp] = useState({ open: false, record: null });
    const [appsByProject, setAppsByProject] = useState(() => ({ ...MOCK_APPS }));
    const { getState, getStatus, upload } = useUIDesign();
    const [uiUpload, setUiUpload] = useState({ open: false, record: null });
    const [appModal, setAppModal] = useState({ open: false, record: null });
    const { getStatus: getAuditStatus, getAudit, approve, reject } = useAudit();
    const [auditDrawer, setAuditDrawer] = useState({ open: false, record: null });
    const { getArchived, archive, unarchive, archivedIds } = useArchive();
    const [archiveOpen, setArchiveOpen] = useState(false);

    const appsOf = (id) => appsByProject[id] || [];

    // App 树：一级 = App 名称；二级 = 系统-区域 + AppID
    const appTreeData = (id) => appsOf(id).map((app, i) => ({
        key: `app-${i}`,
        title: <Text strong>{app.name}</Text>,
        children: (app.versions || []).map((v, j) => ({
            key: `app-${i}-v-${j}`,
            isLeaf: true,
            title: (
                <Space size={8}>
                    <Tag color="blue" style={{ border: 'none' }}>{`${v.platformLabel}-${v.regionLabel}`}</Tag>
                    <Text code style={{ fontSize: 12 }}>{v.appId}</Text>
                </Space>
            ),
        })),
    }));

    // 创建应用成功：新建应用组则追加；加入已有应用组则按 id 合并（更新版本列表）
    const handleAppCreated = (app) => {
        if (!createApp.record || !app) return;
        const id = createApp.record.id;
        setAppsByProject((prev) => {
            const list = prev[id] || [];
            const idx = list.findIndex((a) => a.id === app.id);
            const next = idx >= 0 ? list.map((a, i) => (i === idx ? app : a)) : [...list, app];
            return { ...prev, [id]: next };
        });
    };

    const handleSearch = () => {
        setLoading(true);
        setTimeout(() => {
            let data = [...MOCK_LIST];
            if (filters.company) data = data.filter((r) => r.companyName.includes(filters.company));
            if (filters.appName) data = data.filter((r) => r.appName.includes(filters.appName));
            setRecords(data);
            setLoading(false);
        }, 200);
    };

    const handleReset = () => {
        setFilters({ company: '', appName: '' });
        setLoading(true);
        setTimeout(() => { setRecords(MOCK_LIST); setLoading(false); }, 200);
    };

    // 打开管理端详情，并可定位到指定阶段 / UI设计 Tab
    const openDetail = (record, state) => navigate(`/app/oem-custom-audit/detail/${record.id}`, { state });

    // 阶段列：进度条 + `x/y 项`（链接色，点击 = 查看该阶段资料并定位）+ 构建入口（满足条件时）
    const stageCol = (title, key, stage) => ({
        title, key, width: 175,
        render: (_, r) => {
            const s = r[key] || {};
            const percent = s.total ? Math.round((s.done / s.total) * 100) : 0;
            const st = buildStates[`${r.id}:${stage}`];
            const built = st === 'done' || st === 'failed' || st === 'building';
            const showBuild = isStageFull(stage, r) || built;
            return (
                <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Progress percent={percent} size="small" showInfo={false} style={{ flex: 1, marginBottom: 0 }} />
                        <Button type="link" size="small" style={{ padding: 0, height: 'auto', fontSize: 12 }}
                            title={`查看${STAGE_NAME[stage]}资料`} onClick={() => openDetail(r, { stage })}>
                            {s.done}/{s.total} 项
                        </Button>
                    </div>
                    {showBuild && (
                        <div style={{ marginTop: 2 }}>
                            <StageBuildAction stage={stage} record={r} buildStates={buildStates}
                                uiConfirmed={getStatus(r.id) === 'confirmed'} onOpen={openBuild} />
                        </div>
                    )}
                </div>
            );
        },
    });

    const columns = [
        {
            title: '定制企业', key: 'company', width: 150,
            render: (_, r) => (
                <div>
                    <div style={{ fontSize: 13, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                        title={r.companyName}>{r.companyName}</div>
                    <div style={{ fontSize: 11, color: 'rgba(0,0,0,0.45)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                        title={r.companyId}>{r.companyId}</div>
                </div>
            ),
        },
        { title: '应用名称', dataIndex: 'appName', width: 90, render: (v) => <Text strong>{v}</Text> },
        {
            title: '定制状态', key: 'audit', width: 92,
            render: (_, r) => {
                const info = auditStatusInfo(getAuditStatus(r.id));
                return <Tag color={info.adminColor} style={{ border: 'none' }}>{info.adminText}</Tag>;
            },
        },
        { title: '定制范围', key: 'targets', width: 130, render: (_, r) => <TargetTags targets={r.targets} /> },
        stageCol('第一阶段资料', 'p1', 'phase1'),
        stageCol('第二阶段资料', 'p2', 'phase2'),
        {
            title: 'UI设计', key: 'ui', width: 120,
            render: (_, r) => {
                const st = getStatus(r.id);
                const info = UI_STATUS[st];
                const last = currentVersion(getState(r.id));
                const needUpload = st === 'none' || st === 'rejected';
                const linkText = st === 'none' ? '上传' : st === 'rejected' ? '替换' : '查看';
                const linkTip = st === 'none' ? '上传 UI 设计' : st === 'rejected' ? '替换 UI 设计（重新提交后需客户重新确认）' : '查看 UI 设计';
                const tag = <Tag color={info.color} style={{ border: 'none' }}>{uiStatusLabel(st, true)}</Tag>;
                return (
                    <Space size={4} wrap>
                        {st === 'rejected' && last?.rejectReason
                            ? <Tooltip title={`驳回理由：${last.rejectReason}`}>{tag}</Tooltip>
                            : tag}
                        <Button type="link" size="small" style={{ padding: 0, height: 'auto' }} title={linkTip}
                            onClick={() => (needUpload
                                ? setUiUpload({ open: true, record: r })
                                : openDetail(r, { tab: 'ui' }))}>
                            {linkText}
                        </Button>
                    </Space>
                );
            },
        },
        {
            title: 'App', key: 'app', width: 150,
            render: (_, r) => {
                const apps = appsOf(r.id);
                // 未创建
                if (!apps.length) return <Text type="secondary" style={{ fontSize: 12 }}>未创建</Text>;
                // 单个 App → 直接展示「App名称 + AppID」
                if (apps.length === 1) {
                    const app = apps[0];
                    const first = app.versions?.[0];
                    const multiVer = (app.versions?.length || 0) > 1;
                    const node = (
                        <div>
                            <div style={{ fontSize: 12, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                title={app.name}>{app.name}</div>
                            <div style={{ fontSize: 11, color: 'rgba(0,0,0,0.45)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                title={(app.versions || []).map((v) => v.appId).join(' / ')}>
                                {first?.appId || '-'}{multiVer ? ` 等 ${app.versions.length} 个` : ''}
                            </div>
                        </div>
                    );
                    return multiVer
                        ? <Tooltip title="该 App 有多个版本，点击查看"><span style={{ cursor: 'pointer' }} onClick={() => setAppModal({ open: true, record: r })}>{node}</span></Tooltip>
                        : node;
                }
                // 多个 App → 展示数量，点击弹窗看树形结构
                return (
                    <Button type="link" size="small" style={{ padding: 0, fontSize: 12 }} title="点击查看 App 列表"
                        onClick={() => setAppModal({ open: true, record: r })}>
                        {apps.length} 个
                    </Button>
                );
            },
        },
        { title: '创建时间', dataIndex: 'createdAt', width: 110, render: (v) => <Text style={{ fontSize: 12 }}>{v}</Text> },
        {
            title: '操作', key: 'action', width: 210, fixed: 'right',
            render: (_, r) => {
                const pendingAudit = getAuditStatus(r.id) === 'pending';
                return (
                    <Space size={8} wrap={false}>
                        {/* 待审核：优先展示「审核」入口 */}
                        {pendingAudit && (
                            <Button type="primary" size="small" onClick={() => setAuditDrawer({ open: true, record: r })}>审核</Button>
                        )}
                        {/* 已创建 App 时不再显示创建入口（创建情况见 App 列） */}
                        {!pendingAudit && appsOf(r.id).length === 0 && buildStates[`${r.id}:phase1`] === 'done' && (
                            <Button type="primary" size="small" onClick={() => setCreateApp({ open: true, record: r })}>创建应用</Button>
                        )}
                        <Button type="link" size="small" style={{ padding: 0 }} onClick={() => openDetail(r)}>查看详情</Button>
                        <Popconfirm title="归档该项目？" description="归档后将从列表隐藏，可在「已归档」中取消归档。" okText="归档" cancelText="取消"
                            onConfirm={() => { archive(r.id); message.success('已归档'); }}>
                            <Button type="link" size="small" style={{ padding: 0 }}>归档</Button>
                        </Popconfirm>
                    </Space>
                );
            },
        },
    ];

    // 已归档项目（从主列表隐藏，仅可取消归档）
    const archivedRecords = MOCK_LIST.filter((r) => getArchived(r.id));
    const archivedColumns = [
        {
            title: '定制企业', key: 'company', width: 210,
            render: (_, r) => (
                <div>
                    <div style={{ fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={r.companyName}>{r.companyName}</div>
                    <div style={{ fontSize: 11, color: 'rgba(0,0,0,0.45)' }}>{r.companyId}</div>
                </div>
            ),
        },
        { title: '应用名称', dataIndex: 'appName', width: 120, render: (v) => <Text strong>{v}</Text> },
        {
            title: '定制状态', key: 'audit', width: 92,
            render: (_, r) => {
                const info = auditStatusInfo(getAuditStatus(r.id));
                return <Tag color={info.adminColor} style={{ border: 'none' }}>{info.adminText}</Tag>;
            },
        },
        { title: '定制范围', key: 'targets', width: 150, render: (_, r) => <TargetTags targets={r.targets} /> },
        { title: '归档时间', key: 'archivedAt', width: 160, render: (_, r) => <Text style={{ fontSize: 12 }}>{getArchived(r.id)?.archivedAt}</Text> },
        {
            title: '操作', key: 'action', width: 100,
            render: (_, r) => (
                <Popconfirm title="取消归档该项目？" description="取消后项目将回到「定制管理」主列表。" okText="取消归档" cancelText="取消"
                    onConfirm={() => { unarchive(r.id); message.success('已取消归档'); }}>
                    <Button type="link" size="small" style={{ padding: 0 }}>取消归档</Button>
                </Popconfirm>
            ),
        },
    ];

    return (
        <div style={{ padding: 24 }}>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Title level={4} style={{ margin: 0 }}>定制管理</Title>
                <Button icon={<InboxOutlined />} onClick={() => setArchiveOpen(true)}>已归档({archivedIds.length})</Button>
            </div>

            <Card bordered={false} style={{ marginBottom: 8, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
                <Form layout="inline">
                    <Form.Item label="企业名称" style={{ marginBottom: 0 }}>
                        <Input allowClear placeholder="请输入企业名称" style={{ width: 200 }} value={filters.company}
                            onChange={(e) => setFilters((p) => ({ ...p, company: e.target.value }))} />
                    </Form.Item>
                    <Form.Item label="应用名称" style={{ marginBottom: 0 }}>
                        <Input allowClear placeholder="请输入应用名称" style={{ width: 180 }} value={filters.appName}
                            onChange={(e) => setFilters((p) => ({ ...p, appName: e.target.value }))} />
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 0 }}>
                        <Space>
                            <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                            <Button icon={<ReloadOutlined />} onClick={handleReset}>重置</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>

            <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
                <Table
                    columns={columns}
                    dataSource={records.filter((r) => !getArchived(r.id))}
                    loading={loading}
                    rowKey="key"
                    pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }}
                    scroll={{ x: 1300 }}
                />
            </Card>

            {drawerElement}

            <UIDesignUploadDrawer
                open={uiUpload.open}
                record={uiUpload.record}
                state={getState(uiUpload.record?.id)}
                onClose={() => setUiUpload({ open: false, record: null })}
                onSubmit={(screens, note) => upload(uiUpload.record?.id, { screens, note })}
            />

            <CreateAppDrawer
                open={createApp.open}
                record={createApp.record}
                onCreated={handleAppCreated}
                onClose={() => setCreateApp({ open: false, record: null })}
            />

            <AuditDrawer
                open={auditDrawer.open}
                record={auditDrawer.record}
                state={getAudit(auditDrawer.record?.id)}
                onClose={() => setAuditDrawer({ open: false, record: null })}
                onApprove={approve}
                onReject={reject}
            />

            <Modal
                title={`App 信息 · ${appModal.record?.appName || ''}`}
                open={appModal.open}
                onCancel={() => setAppModal({ open: false, record: null })}
                footer={null}
                width={520}
                destroyOnClose
            >
                <Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 12 }}>
                    一级：App 名称｜二级：系统-区域 + AppID
                </Text>
                <Tree
                    key={appModal.record?.id || 'none'}
                    selectable={false}
                    defaultExpandAll
                    treeData={appTreeData(appModal.record?.id)}
                />
            </Modal>

            <Drawer
                title={`已归档项目（${archivedRecords.length}）`}
                open={archiveOpen}
                width={880}
                onClose={() => setArchiveOpen(false)}
            >
                <Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 12 }}>
                    已归档项目仅可「取消归档」，不提供其他操作；归档为平台侧操作，不影响企业端「我的定制」。
                </Text>
                <Table
                    columns={archivedColumns}
                    dataSource={archivedRecords}
                    rowKey="id"
                    size="small"
                    pagination={false}
                    locale={{ emptyText: '暂无已归档项目' }}
                />
            </Drawer>
        </div>
    );
};

export default CustomManage;
